import { Trans, useTranslation } from "react-i18next";
import CourseStructureTemplate from "./DesktopCourseStructureTemplate";
import NoItem from "@/components/NoItem";

const CourseStructure = ({
  course,
  isOneToOne,
}: {
  course?: never;
  isOneToOne?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex-[1_1_70%] gap-4 flex flex-col p-4 rounded-md h-full bg-white">
      <p className="text-secondary text-sm font-semibold">
        <Trans
          i18nKey="home.course.course_structure"
          defaults="Your course structure"
        />
      </p>
      <div className="flex flex-col justify-center item-center h-full min-h-0 flex-[1_1_0] w-full">
        {course ? (
          <CourseStructureTemplate isOneToOne={isOneToOne} course={course} />
        ) : (
          <NoItem
            className="m-auto bg-gradient h-full !min-h-[100%] text-white rounded-[7px] w-full"
            text={t("home.course.not_available", {
              defaultValue: "Not available now",
            })}
          />
        )}
      </div>
      {/* <div className="flex flex-row w-full justify-between items gap-4 px-6">
        <div className="flex flex-row items-center gap-4">
          <Button variant="ghost" className="w-fit">
            <svg
              width="29"
              height="26"
              viewBox="0 0 29 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 11.4615C1 6.53023 1 4.06392 2.53262 2.53262C4.06392 1 6.53023 1 11.4615 1H16.6923C21.6236 1 24.0899 1 25.6212 2.53262C27.1538 4.06392 27.1538 6.53023 27.1538 11.4615V14.0769C27.1538 19.0082 27.1538 21.4745 25.6212 23.0058C24.0899 24.5385 21.6236 24.5385 16.6923 24.5385H11.4615C6.53023 24.5385 4.06392 24.5385 2.53262 23.0058C1 21.4745 1 19.0082 1 14.0769V11.4615Z"
                fill="#E7DEFF"
                stroke="#8065C9"
                stroke-width="2"
              />
              <path
                d="M17.2271 11.8078C17.4594 11.9187 17.6547 12.0889 17.7912 12.2994C17.9277 12.51 18 12.7526 18 13C18 13.2474 17.9277 13.49 17.7912 13.7006C17.6547 13.9111 17.4594 14.0813 17.2271 14.1922L13.0262 16.8594C12.8128 16.9609 12.5757 17.0089 12.3373 16.9986C12.0989 16.9884 11.8673 16.9204 11.6643 16.8009C11.4613 16.6815 11.2937 16.5147 11.1775 16.3162C11.0612 16.1178 11.0001 15.8944 11 15.6671V10.3329C11.0001 10.1056 11.0612 9.8822 11.1775 9.68377C11.2937 9.48534 11.4613 9.3185 11.6643 9.19907C11.8673 9.07963 12.0989 9.01157 12.3373 9.00135C12.5757 8.99113 12.8128 9.03908 13.0262 9.14065L17.2271 11.8078ZM16.6012 13L12.4003 10.3329V15.6671L16.6012 13Z"
                fill="#8065C9"
              />
            </svg>
          </Button>
          <p className="text-xs leading-[120%]">
            <Trans
              i18nKey="home.course.watch_video_message"
              defaults="If you want to delve into the specifics of the course, watch the video that will explain everything in detail"
            />
          </p>
        </div>
        <Button size="sm">
          <Trans i18nKey="home.course.watch_video" defaults="Watch video" />
        </Button>
      </div> */}
    </div>
  );
};
export default CourseStructure;
